"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailInitRequest = void 0;
var DetailInitRequest = /** @class */ (function () {
    function DetailInitRequest() {
    }
    return DetailInitRequest;
}());
exports.DetailInitRequest = DetailInitRequest;
;
//# sourceMappingURL=detailInit.request.js.map